module.exports = __webpack_public_path__ + "static/media/undraw_collaboration.a6cdaa72.svg";